module.exports = __webpack_public_path__ + "img/texting.506881bb.jpg";